import { ReactNode, useRef } from 'react';

import { BaseMessage } from '@/common/impressions/common';
import {
  UseSlideImpression,
  UseSliderImpressionOptions,
  useSliderImpression,
} from '@/common/impressions/useSliderImpression';

import Slider, { SliderProps } from './Slider';

interface Props<SlideType, ImpressionMessage extends BaseMessage>
  extends Omit<SliderProps<SlideType>, 'renderSlide'> {
  renderSlide: (
    slide: SlideType,
    index: number,
    useSlideImpression: UseSlideImpression<ImpressionMessage>,
  ) => ReactNode;
  impressionOptions?: UseSliderImpressionOptions;
}

const SliderWithImpressions = <SlideType, ImpressionMessage extends BaseMessage>({
  renderSlide,
  impressionOptions,
  ...props
}: Props<SlideType, ImpressionMessage>) => {
  const sliderRef = useRef(null);
  const useSlideImpression = useSliderImpression(sliderRef, impressionOptions);

  return (
    <Slider
      {...props}
      ref={sliderRef}
      renderSlide={(slide, index) => renderSlide(slide, index, useSlideImpression)}
    />
  );
};

export default SliderWithImpressions;
